<tui-data-list
	size="s"
	class="dropdown-columns-actions dropdown-content-root"
>
	@if (isDraggable()) {
		<ul
			class="columns-list"
			cdkDropList
			(cdkDropListDropped)="onDrop($event)"
		>
			@for (column of columns(); track column.column) {
				<li
					cdkDrag
					cdkDragBoundary=".columns-list"
					class="column-item"
					(click)="toggleVisibleColumn(column.column)"
				>
					<div class="column-content">
						@if (showDragIcon()) {
							<tui-icon
								cdkDragHandle
								class="drag-handle"
								icon="@tui.grip-vertical"
								style="--t-icon: url('/images/icons/grid-vertical.svg')"
								(click)="$event.stopPropagation()"
							/>
						}
						<span class="column-label">
							{{ getTranslationByKey(column.column) | translate }}
						</span>
					</div>

					<input
						type="checkbox"
						tuiCheckbox
						size="m"
						class="column-checkbox"
						[checked]="checkVisibleColumn(column.column)"
						(click)="$event.preventDefault()"
					/>

					<ng-template cdkDragPreview>
						<div class="column-item">
							<div class="column-content">
								@if (showDragIcon()) {
									<tui-icon
										icon="@tui.grip-vertical"
										class="drag-handle"
										style="--t-icon: url('/images/icons/grid-vertical.svg')"
									/>
								}
								<span class="column-label">
									{{ getTranslationByKey(column.column) | translate }}
								</span>
							</div>

							<input
								type="checkbox"
								tuiCheckbox
								size="m"
								class="column-checkbox"
								[checked]="checkVisibleColumn(column.column)"
								(click)="$event.preventDefault()"
							/>
						</div>
					</ng-template>
				</li>
			}
		</ul>
	} @else {
		<ul class="columns-list">
			@for (column of columns(); track column.column) {
				<li
					class="column-item"
					(click)="toggleVisibleColumn(column.column)"
				>
					<span class="column-label">
						{{ getTranslationByKey(column.column) | translate }}
					</span>

					<input
						type="checkbox"
						tuiCheckbox
						size="m"
						class="column-checkbox"
						[checked]="checkVisibleColumn(column.column)"
						(click)="$event.preventDefault()"
					/>
				</li>
			}
		</ul>
	}
</tui-data-list>
